import { Component, OnInit, ViewEncapsulation } from '@angular/core';
// import { DataService } from '../../../Services/DataSharingService';
// import { Subscription } from 'rxjs/Subscription';
// import { HeaderService } from '../../../Services/HeaderService';
// import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-message-alert',
  templateUrl: './message-alert.component.html',
  styleUrls: ['./message-alert.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MessageAlertComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }

  ngOnDestroy() {
  }
}



// WEBPACK FOOTER //
// ./src/app/features/message-alert/message-alert.component.ts